import React, { useState } from 'react'
import ButterToast, { Cinnamon } from 'butter-toast'
import { useStateValue } from '../../state'
import { ltiOrgKeyManagement as endpoints } from '@URLS'
import { client } from '@Utils'

export const OrganizationAttributes = ({ organization, contacts }) => {
  const [, dispatch] = useStateValue()
  const [editContact, setEditContact] = useState(false)

  const updateContact = async userId => {
    try {
      let resp = await client.post(endpoints.updateContact(), {
        orgId: organization.id,
        contactId: userId,
      })
      dispatch({
        type: 'selectOrg',
        payload: resp.data,
      })
    } catch (err) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={`There was an error while updating the org contact. ${
              err.response.data ? err.response.data.error : err
            }`}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-exclamation-triangle fa-3x" />}
          />
        ),
      })
    }
    setEditContact(false)
  }

  return (
    <React.Fragment>
      {organization && (
        <ul>
          <li>Tracked on: {organization.createDate}</li>
          <li>Name: {organization.name}</li>
          <li>Internal Name: {organization.internalName}</li>
          <li>Instance Domain: {organization.instanceDomain}</li>
          <li>Test Domain: {organization.testInstanceDomain || 'None'}</li>
          <li>
            Account Level Key?: {organization.hasAccountDevKey ? 'Yes' : 'No'}
          </li>
          <li>
            Org Contact:{' '}
            {editContact ? (
              <React.Fragment>
                <select
                  value={
                    organization.orgContact
                      ? contacts.filter(
                          c => c.email === organization.orgContact
                        )[0].id
                      : ''
                  }
                  name="org_contact"
                  onChange={e => updateContact(e.target.value)}
                >
                  <option value="">Please select a contact</option>
                  {contacts.map((contact, i) => (
                    <option value={contact.id} key={i}>
                      {contact.name} - {contact.email}
                    </option>
                  ))}
                </select>
                <i
                  className="far fa-times ml-3 pointer"
                  onClick={() => setEditContact(false)}
                />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span>{organization.orgContact || 'None'}</span>
                <span
                  className="btn btn-link text-dec-none"
                  onClick={() => setEditContact(true)}
                >
                  edit
                </span>
              </React.Fragment>
            )}
          </li>
        </ul>
      )}
    </React.Fragment>
  )
}
